import { useBookingWizard } from 'core/contexts/bookingWizard';
import { useFormState } from 'react-final-form';
import { Box, Button, Card, CardContent, Typography } from '@mui/material';

const TriperCard = () => {
    const { setActiveStep } = useBookingWizard();
    const { values } = useFormState();

    const handleEdit = () => setActiveStep(1);

    return (
        <Card
            variant="outlined"
            sx={{
                borderRadius: 2,
                boxSizing: 'border-box',
                width: '100%',
            }}
        >
            <CardContent sx={{ p: 2 }}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="subtitle1" fontWeight={600} noWrap>
                        {`${values?.firstName} ${values?.lastName}`}
                    </Typography>

                    <Button size="small" onClick={handleEdit} sx={{ textTransform: 'none', fontWeight: 600 }}>
                        Editar
                    </Button>
                </Box>

                <Box mt={1}>
                    <Typography variant="body2" color="text.secondary">
                        ✉️ {values?.email}
                    </Typography>

                    <Typography variant="body2" color="text.secondary">
                        📞 {values?.mobilePhone}
                    </Typography>
                </Box>
            </CardContent>
        </Card>
    );
};

export default TriperCard;
